module.exports = __webpack_public_path__ + "static/img/i-3.06b958d4.png";